import { jsx } from "react/jsx-runtime";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import { validateTidalLicense } from "../../base/index.js";
function MyLocation(props) {
  return /* @__PURE__ */ jsx(
    MyLocationIcon,
    {
      "data-testid": "MyLocation",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "MyLocation",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
MyLocation.tidalIconMeta = {
  categories: "map,location,time",
  name: "MyLocation"
};
validateTidalLicense();
export {
  MyLocation
};
//# sourceMappingURL=MyLocation.js.map
